interface GroupedEventsIconProps {
  width?: number | string;
  height?: number | string;
  viewBox?: string;
  fill?: string;
}

const DEFAULT_SIZE = 16;

export function GroupedEventsIcon(props: GroupedEventsIconProps) {
  const { width = DEFAULT_SIZE * 1.5, height = DEFAULT_SIZE, viewBox = `0 0 ${DEFAULT_SIZE} ${DEFAULT_SIZE}` } = props;

  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.887887 4.70419L8.16719 8.00633C8.37969 8.10289 8.62 8.10289 8.8325 8.00633L16.1118 4.70419C16.629 4.46951 16.629 3.68796 16.1118 3.45327L8.83281 0.150819C8.7284 0.103098 8.61495 0.0783997 8.50016 0.0783997C8.38536 0.0783997 8.27191 0.103098 8.1675 0.150819L0.887887 3.45296C0.370704 3.68764 0.370704 4.46951 0.887887 4.70419ZM16.1121 7.4629L14.2968 6.6401L9.24562 8.92975C9.00937 9.03694 8.75844 9.09132 8.5 9.09132C8.24157 9.09132 7.99094 9.03694 7.75438 8.92975L2.70349 6.6401L0.887887 7.4629C0.370704 7.69727 0.370704 8.47851 0.887887 8.71288L8.16719 12.0125C8.37969 12.1088 8.62 12.1088 8.8325 12.0125L16.1121 8.71288C16.6293 8.47851 16.6293 7.69727 16.1121 7.4629ZM16.1121 11.4566L14.3037 10.6369L9.24562 12.9297C9.00937 13.0369 8.75844 13.0913 8.5 13.0913C8.24157 13.0913 7.99094 13.0369 7.75438 12.9297L2.69662 10.6369L0.887887 11.4566C0.370704 11.691 0.370704 12.4722 0.887887 12.7066L8.16719 16.0062C8.37969 16.1025 8.62 16.1025 8.8325 16.0062L16.1121 12.7066C16.6293 12.4722 16.6293 11.691 16.1121 11.4566Z"
        fill={props.fill ?? 'black'}
      />
    </svg>
  );
}
